import type { VariableType } from '@/proto/common';
import type { ReactFlowNode } from '../../types';
import {
  type AncestorNodeContext,
  formatVariableRef,
  getAvailableVariables,
  type VariableListItem,
  variableListItemRef,
  variableRefName,
} from '../variableUtils';

/** A suggestion item pairing a variable with what its chip carries. */
export interface SuggestionItem {
  variable: VariableListItem;
  /** Chip id: the node id and the variable's name, a derived name after a dot */
  chipId: string;
  /** Variable name only, shown as the chip text */
  shortLabel: string;
  /** Full label with node prefix, shown as tooltip on hover */
  fullLabel: string;
}

/**
 * Expands the variables the ancestors publish, derived fields included, into
 * the items the variable picker offers, each with what its chip will carry.
 */
export function buildSuggestionItems(
  ancestorVariables: AncestorNodeContext[],
  nodes: ReactFlowNode[],
  typeFilter?: VariableType[]
): SuggestionItem[] {
  return getAvailableVariables(ancestorVariables, typeFilter).map((item) => {
    const ref = variableListItemRef(item);
    return {
      variable: item,
      // TipTap requires every chip to have an id. The chip's reference lives in
      // its own attributes.
      chipId: `${ref.node_id}.${variableRefName(ref)}`,
      shortLabel: formatVariableRef(ref, nodes, 'short'),
      fullLabel: formatVariableRef(ref, nodes),
    };
  });
}
